import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/view/components/ui/form'
import { UseFormReturn } from 'react-hook-form'
import { BannerFormValues } from '../../useBannerForm'
import { Switch } from '@/view/components/ui/switch'
import { Label } from '@radix-ui/react-label'

interface FormFieldCheckboxsProps {
  form: UseFormReturn<BannerFormValues>
  isFixedIndex: boolean
  isSellersCard: boolean
}

export const FormFieldCheckboxs = ({
  form,
  isFixedIndex,
  isSellersCard,
  // isTeamsCard,
}: FormFieldCheckboxsProps) => (
  <div className="flex flex-col items-start justify-evenly gap-4">
    {/* <FormField
      control={form.control}
      name="isTeamsApp"
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <div className="flex items-center gap-2">
              <Switch
                {...field}
                id={field.name}
                value={`${field.value}`}
                checked={isTeamsCard || field.value}
                disabled={isFixedIndex}
                onCheckedChange={(value) => {
                  field.onChange(value)
                }}
              />
              <Label htmlFor={field.name} className="text-sm">
                App equipes
              </Label>
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    /> */}

    <FormField
      control={form.control}
      name="isSellersApp"
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <div className="flex items-center gap-2">
              <Switch
                {...field}
                id={field.name}
                value={`${field.value}`}
                disabled={isFixedIndex}
                checked={isSellersCard || field.value}
                onCheckedChange={(value) => {
                  field.onChange(value)
                }}
              />
              <Label htmlFor={field.name} className="text-sm">
                App vendedores
              </Label>
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />

    <FormField
      control={form.control}
      name="isWebApp"
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <div className="flex items-center gap-2">
              <Switch
                {...field}
                id={field.name}
                value={`${field.value}`}
                disabled={isFixedIndex}
                checked={field.value}
                onCheckedChange={(value) => {
                  field.onChange(value)
                }}
              />
              <Label htmlFor={field.name} className="text-sm">
                Web vendedores
              </Label>
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  </div>
)
